export const announcementsConstants = {
 
    ADD_ANNOUNCEMENTS_REQUEST: 'ADD_ANNOUNCEMENTS_REQUEST',
    ADD_ANNOUNCEMENTS_SUCCESS: 'ADD_ANNOUNCEMENTS_SUCCESS',
    ADD_ANNOUNCEMENTS_FAILURE: 'ADD_ANNOUNCEMENTS_FAILURE',
    FETCH_STATE_REQUEST: 'FETCH_STATE_REQUEST',
    FETCH_STATE_SUCCESS: 'FETCH_STATE_SUCCESS',
    FETCH_STATE_FAILURE: 'FETCH_STATE_FAILURE',
    FETCH_ANNOUNCEMENTS_REQUEST: 'FETCH_ANNOUNCEMENTS_REQUEST',
    FETCH_ANNOUNCEMENTS_SUCCESS: 'FETCH_ANNOUNCEMENTS_SUCCESS',
    FETCH_ANNOUNCEMENTS_FAILURE: 'FETCH_ANNOUNCEMENTS_FAILURE',
    DELETE_ANNOUNCEMENTS_REQUEST: 'DELETE_ANNOUNCEMENTS_REQUEST',
    DELETE_ANNOUNCEMENTS_SUCCESS: 'DELETE_ANNOUNCEMENTS_SUCCESS',
    DELETE_ANNOUNCEMENTS_FAILURE: 'DELETE_ANNOUNCEMENTS_FAILURE',
    GET_ANNOUNCEMENTS_DETAILS_REQUEST: 'GET_ANNOUNCEMENTS_DETAILS_REQUEST',
    GET_ANNOUNCEMENTS_DETAILS_SUCCESS: 'GET_ANNOUNCEMENTS_DETAILS_SUCCESS',
    GET_ANNOUNCEMENTS_DETAILS_FAILURE:'GET_ANNOUNCEMENTS_DETAILS_FAILURE',
    UPDATE_ANNOUNCEMENTS_REQUEST:'UPDATE_ANNOUNCEMENTS_REQUEST',
    UPDATE_ANNOUNCEMENTS_SUCCESS:'UPDATE_ANNOUNCEMENTS_SUCCESS',
    UPDATE_ANNOUNCEMENTS_FAILURE:'UPDATE_ANNOUNCEMENTS_FAILURE',
    FETCH_SITELIST_REQUEST:'FETCH_SITELIST_REQUEST',
    FETCH_SITELIST_SUCCESS:'FETCH_SITELIST_SUCCESS',
    FETCH_SITELIST_FAILURE:'FETCH_SITELIST_FAILURE'       
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/announcementsConstants.js